import { DataTable } from "../ui/dataTable";
import { BiddingProps } from "./BidTableView";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../ui/button";
import CreateBidButton from "../navButtons/CreateBidButton";
//import {ProjectContext} from "../../contexts/ProjectContext";
import React from "react";


function BiddingBuilderSummaryView(props: BiddingProps) {
  const { project_id, scope_id } = useParams<{ project_id: string, scope_id?: string  }>();
  const navigate = useNavigate();
  ///const projectContext = React.useContext(ProjectContext);

  const onViewChart = () => {
    navigate(`/project/${project_id}/bidding-chart`)
  }

  return (
    <div className="relative">
      <div>
        <div className="absolute -top-[55px] right-0">
        {/*<Button variant="outline" type="button" onClick={onViewChart} className="mr-3">*/}
        {/*  View chart*/}
        {/*  </Button>*/}
          <CreateBidButton/>
        </div>
      </div>
      <div>
        <DataTable
          data={props.tableData}
          columns={props.tableColumns}
          handleRowClick={props.handleRowClick}
        />
      </div>
    </div>
  );
}

export default BiddingBuilderSummaryView;
